import { createReducer } from '../utils';
import { actionTypes } from '../actions/integrationsConnectionActions';
import _ from 'lodash';

const initialState = {
  results: [],
  isLoading: false,
  errorMessage: null,
  agreedToPricing: false,
};

export default createReducer(initialState, {
  [actionTypes.REQUEST_CONNECTIONS]: (state) => {
    const next = { errorMessage: null, isLoading: true };
    return Object.assign({}, state, next);
  },
  [actionTypes.RECEIVE_CONNECTIONS]: (state, action) => {
    const next = { results: action.results, isLoading: false };
    return Object.assign({}, state, next);
  },
  [actionTypes.REQUEST_CONNECTION]: (state) => {
    const next = { errorMessage: null, isLoading: true };
    return Object.assign({}, state, next);
  },
  [actionTypes.RECEIVE_CONNECTION]: (state, action) => {
    const next = {
      results: state.results.concat(action.results),
      isLoading: false,
    };
    return Object.assign({}, state, next);
  },
  [actionTypes.REQUEST_DISCONNECTION]: (state) => {
    const next = { errorMessage: null, isLoading: true };
    return Object.assign({}, state, next);
  },
  [actionTypes.RECEIVE_DISCONNECTION]: (state, action) => {
    const results = state.results.filter(p => p.connectionId !== action.connectionId);
    const next = {
      results,
      isLoading: false,
    };
    return Object.assign({}, state, next);
  },
  [actionTypes.UPDATE_CONNECTION]: (state, {connectionId, updates}) => {
    const results = state.results.map( (item) => {
      if ( item.connectionId !== connectionId )
        return item;

      // Otherwise this is the one we are interested in. Update it.
      return { ...item, ...updates }
    });

    return {...state, results };
  },
  [actionTypes.UPDATE_PRICING]: (state, action) => {
    const next = { agreedToPricing: action.agreedToPricing };
    return Object.assign({}, state, next);
  },
  [actionTypes.SERVICE_ERROR]: (state, action) => {
    const next = { errorMessage: action.errorMessage, isLoading: false };
    return Object.assign({}, state, next);
  },
  [actionTypes.REQUEST_FILENAME_TEMPLATE]: (state) => {
    const next = { ...state.filenameTemplate, isLoading: true, errorMessage: null };
    const nextState = { ...state, filenameTemplate: next };
    return Object.assign({}, state, nextState);
  },
  [actionTypes.RECEIVE_FILENAME_TEMPLATE]: (state, {connectionId, updates}) => {
    const results = state.results.map( connection => {
      if (connection.connectionId != connectionId)
        return connection;

      return _.merge({}, connection, {
        filenameSettings: { filenameTemplate: updates }
      });
    });

    return { ...state, results };
  },
  [actionTypes.FILENAME_TEMPLATE_ERROR]: (state, action) => {
    const { errorMessage } = action;
    const next = { ...state.filenameTemplate, errorMessage, isLoading: false };
    const nextState = { ...state, filenameTemplate: next };
    return Object.assign({}, state, nextState);
  },
});



// WEBPACK FOOTER //
// ./src/redux/reducers/kloudlessReducer.js